export const regionData = [
    { label: 'SEATTLE', value: 'pacific-northwest', isDisabled: false },
    { label: 'SAN FRANCISCO BAY AREA', value: 'northern-california', isDisabled: false },
    { label: 'LOS ANGELES', value: 'southern-california', isDisabled: false },
    { label: 'VANCOUVER, BC', value: 'vancouver', isDisabled: false },
];
